import React, { useState } from 'react';
import { IDeveloperStaff } from 'utils/entities';
import MemberPlaceholder from 'assets/svg/developer/team-member.svg';
import { SmallText, Text } from 'ds/components/typography';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { useLocale } from 'locale';
import { DESKTOP_MEMBER_IMAGE_SIZE, MOBILE_MEMBER_IMAGE_SIZE } from 'screens/DeveloperPage/consts';
import * as Styled from './styled';
import { Button } from 'ds/components/button';


export const MemberCard: React.FC<{ member: IDeveloperStaff; }> = ({ member }) => {
  const constructImageURI = useImageUrlBuilder();
  const isMobile = useScreenBreakpoint() === 1;
  const { t } = useLocale();
  const [ showDescription, setShowDescription ] = useState(false);
  const [ avatarFailedToLoad, setAvatarFailedToLoad ] = useState(false);

  const toggleShowDescription = () => setShowDescription(!showDescription);

  const imageSize = isMobile ? MOBILE_MEMBER_IMAGE_SIZE : DESKTOP_MEMBER_IMAGE_SIZE;
  const TextLine = isMobile ? SmallText : Text;
  const hasDescription = Boolean(member.about);

  return (
    <Styled.MemberItem hasDescription={hasDescription}>
      <Styled.MemberImageWrapper>
        {member.imageUrl && !avatarFailedToLoad ? (
          <img onError={() => setAvatarFailedToLoad(true)} src={constructImageURI(member.imageUrl, { height: imageSize, width: imageSize })} alt={member.name} />
        ) : (
          <MemberPlaceholder />
        )}
        <Styled.MemberDescription show={showDescription} className="member-description">
          <TextLine weight={isMobile ? 'normal' : 'medium'}>{member.about}</TextLine>
        </Styled.MemberDescription>
      </Styled.MemberImageWrapper>
      <Styled.MemberName weight={isMobile ? 'medium' : 'bold'}>{member.name}</Styled.MemberName>
      <TextLine weight={isMobile ? 'medium' : 'normal'}>{member.title}</TextLine>
      {hasDescription ? (
        <ShowAt to={2}>
          <Styled.MoreAbout>
            <Button fullWidth mode="ghost" size="large" onClick={toggleShowDescription}>
              {t('developerPage.members.moreAbout')}
            </Button>
          </Styled.MoreAbout>
        </ShowAt>
      ) : null}
    </Styled.MemberItem>
  );
};
